import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import MainLayout from '../pages/MainLayout.jsx';
import { tokenManager } from '../services/axiosInstance.js';
import VisualizeFontss from '../pages/VisualizeFontss.jsx';
import CreateImages from '../pages/CreateImages.jsx';
import PastCreation from '../pages/PastCreation.jsx';
import { useUserData } from '../services/userDataService.js';
import Admin from '../pages/Admin/Admin.jsx';
import Analytics from '../pages/Admin/Analytics.jsx';
import UserHistory from '../pages/Admin/UserHistory.jsx';
import { setIsVisualizePageVisible } from '../redux/pastCreateionsSlice.js';
import TermsAndConditions from '../components/Modals/TermsAndConditions.jsx';
import ServiceDown from '../pages/ServiceDown.jsx';

const RouteWrapper = () => {
  const [token, setToken] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const userData = useUserData();

  const { isVisualizePageVisible } = useSelector((state) => state.createImage);
  const ProtectedIndex = withAuthenticationRequired(MainLayout);

  const ProtectedVisualizeFonts = withAuthenticationRequired(VisualizeFontss);
  const ProtectedCreateImage = withAuthenticationRequired(CreateImages);
  const ProtectedPastCreation = withAuthenticationRequired(PastCreation);
  const ProtectedAdmin = withAuthenticationRequired(Admin);
  const ProtectedUsersHistory = withAuthenticationRequired(UserHistory);
  const ProtectedAnalytics = withAuthenticationRequired(Analytics);

  useEffect(() => {
    const getAccessToken = async () => {
      await getAccessTokenSilently()
        .then((response) => {
          tokenManager.setToken(response);
          setToken(response);
          if (response) {
            userData();
            setIsAuthenticated(true);
          }
        })
        .catch((error) => {
          console.error('Error to get access token : ', error);
        });
    };
    getAccessToken();
  }, [getAccessTokenSilently]);

  return (
    <Routes>
      <Route path='/' element={<ProtectedIndex />}>
        <Route path='/' element={<Navigate to='/generate-image' />} />
        {/* <Route
          path='/generate-image/:urlPrompt?/:urlMd5?/*'
          element={<ServiceDown />}
        /> */}
        <Route
          path='/generate-image/:urlPrompt?/:urlMd5?/*'
          element={
            isVisualizePageVisible ? (
              <ProtectedVisualizeFonts token={token} />
            ) : (
              <ProtectedCreateImage />
            )
          }
        />
        <Route
          path='/generate-image/:urlPrompt?/:urlMd5?/*'
          element={
            isVisualizePageVisible && isAuthenticated && <ProtectedVisualizeFonts token={token} />
          }
        />
        <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
        <Route path='/your-past-creations' element={<ProtectedPastCreation />} />
        <Route path='/admin' element={<ProtectedAdmin />}>
          <Route path='/admin/dashboard' element={<ProtectedUsersHistory />} />
          <Route path='/admin/analytics' element={<ProtectedAnalytics />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default RouteWrapper;
